import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type PhotoPolaroidsIconProps = CreateIconComponentProps;
export const PhotoPolaroidsIcon: React.FC<PhotoPolaroidsIconProps> = ({
  title = 'PhotoPolaroids',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M13.22 4.599 2.922 9.989a.658.658 0 0 0-.278.888l6.041 11.54a.658.658 0 0 0 .888.278l10.296-5.39a.658.658 0 0 0 .278-.888l-6.04-11.54a.658.658 0 0 0-.889-.278Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m9.429 16.814-2.74-5.232 5.7-2.984 2.74 5.233-5.7 2.983Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m6.688 8.137-.493-5.042a.546.546 0 0 1 .493-.59l12.575-1.103a.546.546 0 0 1 .59.493l1.228 14.053a.546.546 0 0 1-.493.59l-.525.047"
    />
  </CreateIconComponent>
);
